<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="text-left">
        <!-- Content of the left div -->
        <h1 id="statistic-summary" class="title mb-1">Activity Summary</h1>
      </div>
      <div class="text-right" style="min-width: 200px">
        <!-- Content of the right div -->
        <div class="input-group">
          <span
            class="input-group-text bg-white"
            style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right: none"
          >
            <i
              class="fas fa-calendar"
              style="
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                color: #333;
              "
            ></i>
          </span>
          <flat-pickr
            :config="angePickr"
            placeholder="Select Date"
            v-model="selected.universalDate"
          ></flat-pickr>
        </div>
      </div>
    </div>

    <!-- Scan Start -->
    <div class="mb-4">
      <div class="innerBox h-100">
        <div class="d-flex">
          <div
            class="col-lg-6 col-md-12 col-12 mb-2"
            style="border-right: 1px solid rgba(0, 0, 0, 0.1); padding: 0"
          >
            <div class="d-flex justify-content-between pt-3">
              <div class="section-title pl-3">
                <h5 style="font-size: 13px; color: #383838; margin-right: 0">
                  Most Scanned Serial Number
                </h5>
                <b-button
                  variant="link"
                  class="p-0"
                  id="most-scanned-serial-number"
                  v-b-tooltip.hover
                  :title="tooltipText"
                >
                  <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                </b-button>
                <b-tooltip
                  target="most-scanned-serial-number"
                  triggers="hover"
                  custom-class="left-aligned-tooltip"
                  html
                >
                  <h5 style="font-size: 13px; color: #383838">Most Scanned Serial Number</h5>
                  <!-- <br> -->
                  Produk yang paling banyak di scan oleh customer berdasarkan nomor seri QR
                  <!-- {{ 'html-tooltip-button-title-' + circle_bg_color }} -->
                </b-tooltip>
              </div>
              <div class="d-flex pr-1">
                <div class="mr-2" style="width: 220px">
                  <Multiselect
                    v-if="filterOptions.provinsi"
                    :options="filterOptions.provinsi.map((x) => x.kode_provinsi)"
                    :custom-label="
                      (opt) =>
                        filterOptions.provinsi.find((x) => x.kode_provinsi == opt).nama_provinsi
                    "
                    :allow-empty="false"
                    :selectLabel="''"
                    :selectedLabel="''"
                    :deselectLabel="''"
                    v-model="filter.mostScanSerialNumber.provinsi"
                    class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
                    placeholder="All Province"
                  />
                </div>
                <div class="mr-2" style="width: 120px">
                  <Multiselect
                    :options="filterOptions.status.map((x) => x.value)"
                    :custom-label="(opt) => filterOptions.status.find((x) => x.value == opt).name"
                    :allow-empty="false"
                    :selectLabel="''"
                    :selectedLabel="''"
                    :deselectLabel="''"
                    v-model="filter.mostScanSerialNumber.status"
                    class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
                    placeholder="All Result"
                  />
                </div>
              </div>
            </div>
            <hr class="mt-3" />
            <Top10ScannedSerialNumberPieChart :data="highlightData.mostScanSerialNumber" />
          </div>
          <div class="col-lg-6 col-md-12 col-12 mb-2" style="padding: 0">
            <div class="d-flex justify-content-between pt-3">
              <div class="section-title pl-3">
                <h5 style="font-size: 13px; color: #383838; margin-right: 0">
                  Most Scanned Product
                </h5>
                <b-button
                  variant="link"
                  class="p-0"
                  id="most-scanned-product"
                  v-b-tooltip.hover
                  :title="tooltipText"
                >
                  <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                </b-button>
                <b-tooltip
                  target="most-scanned-product"
                  triggers="hover"
                  custom-class="left-aligned-tooltip"
                  html
                >
                  <h5 style="font-size: 13px; color: #383838">Most Scanned Product</h5>
                  <!-- <br> -->
                  Produk yang paling banyak di scan oleh customer
                  <!-- {{ 'html-tooltip-button-title-' + circle_bg_color }} -->
                </b-tooltip>
              </div>
              <div class="d-flex pr-1">
                <div class="mr-2" style="width: 220px">
                  <Multiselect
                    v-if="filterOptions.provinsi"
                    :options="filterOptions.provinsi.map((x) => x.kode_provinsi)"
                    :custom-label="
                      (opt) =>
                        filterOptions.provinsi.find((x) => x.kode_provinsi == opt).nama_provinsi
                    "
                    :allow-empty="false"
                    :selectLabel="''"
                    :selectedLabel="''"
                    :deselectLabel="''"
                    v-model="filter.mostScan.kode_provinsi"
                    class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
                    placeholder="All Province"
                  />
                </div>
                <div class="mr-2" style="width: 120px">
                  <Multiselect
                    :options="filterOptions.status.map((x) => x.value)"
                    :custom-label="(opt) => filterOptions.status.find((x) => x.value == opt).name"
                    :allow-empty="false"
                    :selectLabel="''"
                    :selectedLabel="''"
                    :deselectLabel="''"
                    v-model="filter.mostScan.status"
                    class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
                    placeholder="All Result"
                  />
                </div>
              </div>
            </div>
            <hr class="mt-3" />
            <Top10ScannedPieChart :data="highlightData.mostScan" />
          </div>
        </div>
      </div>
    </div>
    <!-- Scan End -->

    <!-- Chart Start -->
    <div class="mb-4">
      <div class="innerBox">
        <div class="d-flex">
          <div class="section-title d-flex align-items-center col-lg-6 col-12 mb-1 py-3">
            <h5 class="mb-0 mr-2" style="font-size: 12px; color: #383838">Activity Trend</h5>
            <b-button
              variant="link"
              class="p-0"
              id="activity-trend"
              v-b-tooltip.hover
              :title="tooltipText"
            >
              <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
            </b-button>
            <b-tooltip
              target="activity-trend"
              triggers="hover"
              custom-class="left-aligned-tooltip"
              html
            >
              <h5>Activity Trend</h5>
              <!-- <br> -->
              Aktifitas scan yang tersebar diberbagai provinsi dengan representatif data scan
              Genuine, Counterfeit dan semua result scan.
              <!-- {{ 'html-tooltip-button-title-' + circle_bg_color }} -->
            </b-tooltip>

            <button
              class="btn mr-2"
              @click="filter.activityTrend.type = 'serial'"
              :class="{
                'btn-primary': filter.activityTrend.type == 'serial',
                'btn-outline-primary': filter.activityTrend.type != 'serial',
              }"
            >
              By Serial Number
            </button>

            <button
              class="btn"
              @click="filter.activityTrend.type = 'product'"
              :class="{
                'btn-primary': filter.activityTrend.type == 'product',
                'btn-outline-primary': filter.activityTrend.type != 'product',
              }"
            >
              By Part Number
            </button>
          </div>
          <!-- <div class="  col-12 mb-1">
                        
                    </div> -->
          <div class="d-flex col-lg-6 justify-content-end py-3">
            <div class="d-flex mb-1 mr-2">
              <!-- <h5>Activity Trend</h5> -->
              <Multiselect
                v-if="filterOptions.provinsi"
                :options="filterOptions.provinsi.map((x) => x.kode_provinsi)"
                :custom-label="
                  (opt) => filterOptions.provinsi.find((x) => x.kode_provinsi == opt).nama_provinsi
                "
                :allow-empty="false"
                :selectLabel="''"
                :selectedLabel="''"
                :deselectLabel="''"
                placeholder="All Province"
                class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
                v-model="filter.activityTrend.provinsi"
              />
            </div>
            <div class="d-flex mb-1 mr-2">
              <!-- <h5>Activity Trend</h5> -->
              <Multiselect
                v-if="filter.activityTrend.type == 'serial'"
                :options="filterOptions.serial"
                placeholder="Serial Number"
                :multiple="true"
                :close-on-select="false"
                :searchable="true"
                :internal-search="false"
                :selectLabel="''"
                :selectedLabel="''"
                :deselectLabel="''"
                @search-change="searchSerialNumber"
                @input="limitSerialSelection"
                v-model="filter.activityTrend.serial_number"
                class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
              >
                <template slot="option" slot-scope="{ option }">
                  <div class="multiselect-option-with-checkbox">
                    <input
                      type="checkbox"
                      :checked="filter.activityTrend.serial_number.includes(option)"
                      @focus.prevent
                      class="multiselect-checkbox"
                    />
                    <span class="multiselect-option-label">{{ option }}</span>
                  </div>
                </template>
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                    Serial Number
                  </span>
                </template>
              </Multiselect>
              <Multiselect
                v-else
                :options="filterOptions.products.map((x) => x.id)"
                :custom-label="(opt) => filterOptions.products.find((x) => x.id == opt).material_no"
                placeholder="Part Number"
                :multiple="true"
                :close-on-select="false"
                :selectLabel="''"
                :selectedLabel="''"
                :deselectLabel="''"
                v-model="filter.activityTrend.product_id"
                class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
              >
                <template slot="option" slot-scope="{ option }">
                  <div class="multiselect-option-with-checkbox">
                    <input
                      type="checkbox"
                      :checked="filter.activityTrend.product_id.includes(option)"
                      @focus.prevent
                      class="multiselect-checkbox"
                    />
                    <span class="multiselect-option-label">
                      {{ filterOptions.products.find((x) => x.id == option).material_no }}
                    </span>
                  </div>
                </template>
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                    Part Number
                  </span>
                </template>
              </Multiselect>
            </div>
            <div class="d-flex mb-1">
              <!-- <h5>Activity Trend</h5> -->
              <Multiselect
                :options="filterOptions.status.map((x) => x.value)"
                :custom-label="(opt) => filterOptions.status.find((x) => x.value == opt).name"
                :allow-empty="false"
                :selectLabel="''"
                :selectedLabel="''"
                :deselectLabel="''"
                v-model="filter.activityTrend.status"
                placeholder="All Result"
                class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
              />
            </div>
          </div>
          <!-- <div class="col-lg-3 col-12 mb-1 d-flex justify-content-between">
                        <button class="btn  flex-fill mr-2" @click="filter.period = 'This Year'" :class="{'btn-primary' : filter.period == 'This Year' , 'btn-outline-primary' : filter.period != 'This Year'}">This Year</button>
                        <button class="btn flex-fill" @click="filter.period = '12 Months'" :class="{'btn-primary' : filter.period == '12 Months' , 'btn-outline-primary' : filter.period != '12 Months'}">12 Months</button>
                    </div> -->
        </div>
        <activity-chart
          :data="highlightData.activityTrend"
          v-if="highlightData.activityTrend.length > 0"
        ></activity-chart>
        <activity-chart
          :data="{
            bulan: 10,
            year: 2023,
            value: 1,
          }"
          v-else
        ></activity-chart>
      </div>
    </div>
    <!-- Chart End -->

    <MapPopup
      :fields="[]"
      :urlAPI="''"
      v-if="selectQR"
      @closeModal="selectQR = null"
      latVar="lat"
      lngVar="lng"
    />
  </div>
</template>

<script>
import qs from "qs";

// import Map from './children/Map.vue'
import moment from "moment";
import Multiselect from "vue-multiselect";
import activityChart from "./children/ActivityChart.vue";
import debounce from "debounce";

import Top10ScannedPieChart from "./children/Top10ScannedPieChart.vue";
import Top10ScannedSerialNumberPieChart from "./children/Top10ScannedSerialNumberPieChart.vue";

import testImage from "@/assets/img/test_image.png";
import MapPopup from "@/components/MapPopup.vue";

export default {
  metaInfo: {
    title: "Activity Summary",
  },
  components: {
    // AktivasiAktivasi,
    // Map,
    Multiselect,
    // ProvinceTable,
    // ProviceChart,
    // highlightStats,
    activityChart,
    Top10ScannedPieChart,
    Top10ScannedSerialNumberPieChart,
    MapPopup,
  },
  mounted() {
    this.filterOptions.provinsi = [
      { nama_provinsi: "All Province", kode_provinsi: "all provinsi" },
      ...this.$store.getters.getProvinsi,
    ];

    // this.loadApi(null , null)
    // this.loadProvinsi()
    this.filter.activityTrend.product_id = this.filterOptions.products.map((x) => x.id);
    this.loadTopScan();
    this.loadMostScanSerialNumber();
    this.loadMostScan();
    this.loadActivityChart();
    // this.loadMostActiveRegion()

    // let sum = 30000
    // let index = 34;

    // let randAmount = this.distributeRandomly(index , sum , 14500).sort((a, b) => b - a)

    // this.mapDemoData = randAmount
  },
  watch: {
    "selected.universalDate": function () {
      this.debounceMethod(this);
    },
    // 'selected.topScanDate' : function () {
    //     let split = this.selected.topScanDate.split(" to ");
    //     console.log(split)
    //     this.filter.topScan.start = moment(split[0],'DD/MM/Y').format('Y-MM-DD');
    //     this.filter.topScan.end = split.length > 1 ? moment(split[1],'DD/MM/Y').format('Y-MM-DD') : moment(split[0] ,'DD/MM/Y').format('Y-MM-DD');

    //     this.loadTopScan()
    // },
    // 'selected.date' : function () {
    //     let split = this.selected.date.split(" to ");
    //     console.log(split)
    //     this.filter.map.start = moment(split[0],'DD/MM/Y').format('Y-MM-DD');
    //     this.filter.map.end = split.length > 1 ? moment(split[1],'DD/MM/Y').format('Y-MM-DD') : moment(split[0] ,'DD/MM/Y').format('Y-MM-DD');

    //     // this.loadMostActiveRegion()
    // },
    // 'filter.period' : function () {
    //     if(this.filter.period == 'This Year') {
    //         this.$nextTick(() => {
    //             this.filter.activityTrend.start = new moment().startOf('year').format('Y-MM-DD')
    //             this.filter.activityTrend.end = new moment().endOf('year').format('Y-MM-DD')
    //         })

    //     }
    //     else {
    //         this.$nextTick(() => {
    //             this.filter.activityTrend.start = new moment().startOf('month').add('-12' , 'month').format('Y-MM-DD')
    //             this.filter.activityTrend.end = new moment().endOf('month').format('Y-MM-DD')
    //         })

    //     }
    // },
    "filter.mostScanSerialNumber": {
      deep: true,
      handler() {
        this.loadMostScanSerialNumber();
      },
    },
    "filter.mostScan": {
      deep: true,
      handler() {
        this.loadMostScan();
      },
    },
    "filter.activityTrend": {
      deep: true,
      handler() {
        this.loadActivityChart();
      },
    },
  },
  data() {
    let startOfMonth = new moment().startOf("month");

    let endOfMonth = new moment().endOf("month");

    let startOfYear = new moment().startOf("year");
    let endOfYear = new moment().endOf("year");

    let formattedStartOfYear = startOfYear.format("Y-MM-DD");
    let formattedEndOfYear = endOfYear.format("Y-MM-DD");

    let yearList = [];

    for (var i = parseInt(new moment().format("Y")); i > 2000; i--) {
      yearList.push(i);
    }
    return {
      moment,
      // filter.activityTrend.type : 'serial',
      angePickr: {
        mode: "range",
        dateFormat: "d/m/Y",
        altInput: true,
        altFormat: "d/m/Y",
        altInputClass: "form-control input elegant-flatpickr border-left-0",
      },
      selected: {
        // dateButtonsIndex : 2,
        date: `${startOfYear.format("DD/MM/Y")} to ${endOfYear.format("DD/MM/Y")}`,
        topScanDate: `${startOfYear.format("DD/MM/Y")} to ${endOfYear.format("DD/MM/Y")}`,
        universalDate: `${startOfYear.format("DD/MM/Y")} to ${endOfYear.format("DD/MM/Y")}`,
      },
      invokeCenter: null,
      mapDemoData: null,
      // kabupatenDataSum : 0,
      // kecamatanDataSum : 0,
      // kelurahanDataSum : 0,
      // tpsDataSum : 0,
      filter: {
        activityTrend: {
          provinsi: "all provinsi",
          serial_number: [],
          start: formattedStartOfYear,
          end: formattedEndOfYear,
          status: "all result",
          type: "serial",
          product_id: [],
        },
        latestActivity: {
          search: "",
          page: 1,
          limit: 10,
        },
        topScan: {
          start: formattedStartOfYear,
          end: formattedEndOfYear,
        },
        mostScanSerialNumber: {
          provinsi: "all provinsi",
          status: "all result",
          start: formattedStartOfYear,
          end: formattedEndOfYear,
        },
        mostScan: {
          kode_provinsi: "all provinsi",
          status: "all result",
          start: formattedStartOfYear,
          end: formattedEndOfYear,
          // year : parseInt(new moment().format('Y'))
        },
        selectedDate: `${startOfMonth} to ${endOfMonth}`,
        period: "This Year",
      },
      filterOptions: {
        status: [
          {
            name: "All Result",
            value: "all result",
          },
          {
            name: "Genuine",
            value: "genuine",
          },
          {
            name: "Counterfeit",
            value: "counterfeit",
          },
        ],
        products: this.$store.getters.getProducts,
        provinsi: null,
        serial: [],
        scan: [
          {
            name: "Activity By Register",
            value: "register",
          },
          {
            name: "Activity By Scan",
            value: "scan",
          },
        ],
        year: yearList,
      },
      highlightData: {
        stats: {
          total_qr: null,
          total_scan: null,
          genuine_found: null,
          counterfeit_found: null,
        },
        latestActivity: [],
        fullActivity: [],
        topScan: [],
        mostScanSerialNumber: [],
        mostScan: [],
        activityTrend: [],
        mostActiveRegion: null,
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input elegant-flatpickr",
      },
      selectQR: null,
      demoLocation: ["DKI Jakarta", "Jawa Barat", "Medan", "Manado", "Tangerang"],
      total_qr: 0,
    };
  },
  methods: {
    debounceMethod: debounce((vm) => {
      let split = vm.selected.universalDate.split(" to ");
      // console.log(split)
      let start = moment(split[0], "DD/MM/Y").format("Y-MM-DD");
      let end =
        split.length > 1
          ? moment(split[1], "DD/MM/Y").format("Y-MM-DD")
          : moment(split[0], "DD/MM/Y").format("Y-MM-DD");

      vm.filterOptions.serial.length = 0;

      vm.filter.mostScan.start = start;
      vm.filter.mostScan.end = end;

      vm.filter.mostScanSerialNumber.start = start;
      vm.filter.mostScanSerialNumber.end = end;
      vm.filter.mostScanSerialNumber.provinsi = "all provinsi";
      vm.filter.mostScanSerialNumber.status = "all result";

      vm.filter.activityTrend.start = start;
      vm.filter.activityTrend.end = end;
    }, 1500),
    viewJourney(qrcode) {
      this.$router.push({ name: "HighlightsQRJourney", params: { qrcode: qrcode } });
    },
    async loadActivityData() {
      try {
        let response = await this.$http.get(
          `/api/highlight/activities?${qs.stringify(this.filter.aktivasi)}`
        );

        this.activityData = response.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    getColor(persen) {
      persen = parseFloat(persen);

      if (persen == 0) {
        return "#fbb9b9";
      } else if (persen <= 10) {
        return "rgba(162, 218, 162 , 0.1)";
      } else {
        return `rgba(162, 218, 162 , ${(Math.round(persen / 10) * 10) / 100})`;
      }
    },
    async loadTopScan() {
      try {
        this.highlightData.topScan = [];
        let resp = await this.$http.get(
          "/activity-report/top-ten-scanned-products?" + qs.stringify(this.filter.topScan)
        );

        this.highlightData.topScan = JSON.parse(JSON.stringify(resp.data.data));
      } catch (err) {
        console.log(err);
      }
    },
    async loadMostScanSerialNumber() {
      try {
        this.highlightData.mostScanSerialNumber = [];

        let filter = JSON.parse(JSON.stringify(this.filter.mostScanSerialNumber));
        filter.status == "all result" && delete filter.status;
        filter.provinsi == "all provinsi" && delete filter.provinsi;

        let resp = await this.$http.get(
          "/activity-report/most-scanned-serial-number?" + qs.stringify(filter, { skipNulls: true })
        );
        let respMasterSerialNumber = await this.$http.get("/activity-report/master-serial-number");

        this.highlightData.mostScanSerialNumber = JSON.parse(JSON.stringify(resp.data.data));

        let dataSerial = respMasterSerialNumber.data.data.map((x) => x.serial_number);
        this.filterOptions.serial = dataSerial;

        if (this.filter.activityTrend.serial_number.length === 0) {
          let top3Serials = resp.data.data.slice(0, 3).map((x) => x.serial_number);
          this.filter.activityTrend.serial_number = top3Serials;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async loadMostScan() {
      try {
        this.highlightData.mostScan = [];

        let filter = JSON.parse(JSON.stringify(this.filter.mostScan));
        filter.status == "all result" && delete filter.status;
        filter.kode_provinsi == "all provinsi" && delete filter.kode_provinsi;

        let resp = await this.$http.get(
          "/activity-report/most-scanned-product-by-date?" +
            qs.stringify(filter, { skipNulls: true })
        );

        this.highlightData.mostScan = JSON.parse(JSON.stringify(resp.data.data));
      } catch (err) {
        console.log(err);
      }
    },
    async loadActivityChart() {
      try {
        let customFilter = JSON.parse(JSON.stringify(this.filter.activityTrend));

        if (customFilter.type === "serial" && customFilter.serial_number.length === 0) {
          return;
        }

        if (customFilter.serial_number.length > 0) {
          customFilter.serial_number = customFilter.serial_number.join(",");
        } else {
          delete customFilter.serial_number;
        }

        customFilter.status == "all result" && delete customFilter.status;
        customFilter.provinsi == "all provinsi" && delete customFilter.provinsi;

        customFilter.product_id = customFilter.product_id.join(",");
        let response = await this.$http.get(
          "/activity-report/activity-trends?" + qs.stringify(customFilter)
        );

        let data = this.formatData(response.data);
        // let dataSerial = responseSerial.data.data.map(x => x.serial_number)
        console.log("ini data testing", response.data);
        this.highlightData.activityTrend = data;
        // // console.log(dataSerial)
        // this.filterOptions.serial = dataSerial

        // this.filter.activityTrend.serial_number = dataSerial
      } catch (err) {
        console.log(err);
        this.highlightData.activityTrend = [];
      }
    },
    formatData(jsonData) {
      const { categories, series } = jsonData.data;

      let serialList = series.map((x) => x.name);
      const formattedData = categories.map((date, index) => {
        let obj = {
          date: date,
        };
        for (var i = 0; i < serialList.length; i++) {
          obj[serialList[i]] = series[i].data[index];
        }

        return obj;
      });
      return formattedData;
    },
    limitSerialSelection(value) {
      if (value && value.length > 3) {
        this.filter.activityTrend.serial_number = value.slice(-3);
      }
    },
    searchSerialNumber: debounce(async function (query) {
      try {
        if (!query || query.length < 1) {
          const params = {
            start: this.filter.activityTrend.start,
            end: this.filter.activityTrend.end,
          };
          let resp = await this.$http.get(
            "/activity-report/master-serial-number?" + qs.stringify(params)
          );
          this.filterOptions.serial = resp.data.data.map((x) => x.serial_number);
        } else {
          const params = {
            start: this.filter.activityTrend.start,
            end: this.filter.activityTrend.end,
            search: query,
          };
          let resp = await this.$http.get(
            "/activity-report/master-serial-number?" + qs.stringify(params)
          );
          this.filterOptions.serial = resp.data.data.map((x) => x.serial_number);
        }
      } catch (err) {
        console.log(err);
        this.filterOptions.serial = [];
      }
    }, 500),
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  /* padding: 20px; */
}
.statsData {
  padding: 10px 7px;
}

.btn {
  /* height: 43px; */
}

.stats {
  font-size: 1.3rem;
  font-weight: 600;
}

.bg-kabupaten {
  background-color: darkorange;
}
.bg-kecamatan {
  background-color: blueviolet;
}
.bg-desakel {
  background-color: darkslategray;
}
.bg-tps {
  background-color: dodgerblue;
}

.column-region {
  height: 400px;
  overflow-y: scroll;
}

.section-title h5[data-v-7b2661ec] {
  margin-bottom: 0;
  margin-right: 5px;
}
</style>

<style scoped>
th {
  border-top: none;
  font-weight: normal;
  /* font-family: Proxima Nova; */
}
.horizontal-line {
  border-top: 1px solid #a2a2a2;
  margin: 5px 0;
  width: 100%;
  height: 1px;
}

.input-with-icon {
  position: relative;
}

.fa-placeholder {
  font-family: "Font Awesome 5 Pro";
  font-weight: 900; /* This ensures the solid icon is used */
  position: absolute;
  left: 10px; /* Adjust as needed */
  top: 50%;
  transform: translateY(-50%);
  color: #ccc; /* Placeholder-like color */
  pointer-events: none; /* Ensures clicks go through to the input */
}

.form-control {
  padding-left: 25px; /* Make space for the icon */
}

.progress-container {
  display: flex;
  align-items: center; /* Center vertically */
}

.progress {
  flex-grow: 1; /* Allow progress bar to take full width */
}

.value-label {
  margin-left: 10px; /* Spacing between progress bar and label */
  white-space: nowrap; /* Prevents wrapping of the label */
}

.title {
  font-size: 16px !important;
  font-weight: 500;
  font-size: 20px;
  height: 17px !important;
}

.section-title {
  font-size: 13px !important;
  color: #6c757d !important;
  font-weight: 700 !important;
}
.section-title {
  display: flex;
  align-items: center;
  flex-wrap: nowrap; /* Prevents wrapping to the next line */
}

.section-title h5 {
  margin-bottom: 0; /* Removes bottom margin from the h5 */
  margin-right: 10px; /* Adds spacing after the h5 */
}

.btn {
  margin-right: 10px; /* Adds spacing between buttons */
}

.multiselect-option-with-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

.multiselect-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.multiselect-option-label {
  flex: 1;
  cursor: pointer;
}
</style>
